import React from 'react'
import { useSelector } from 'react-redux'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { selectAppName } from 'src/redux/selectors/session.selectors'

interface ForVendorsAndContractorsTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const ForVendorsAndContractorsTooltip: React.FC<
  ForVendorsAndContractorsTooltipProps
> = (props): React.ReactElement => {
  const appName = useSelector(selectAppName)

  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        <Trns
          source={
            'These cards can be created for recipients outside of your org in ${appName}, and do not require a login to be viewed and used by the recipient.'
          }
          expressions={{
            appName: appName,
          }}
        />
      </p>
    </Tooltip>
  )
}

export default ForVendorsAndContractorsTooltip
